import { render, staticRenderFns } from "./formgroupphone.vue?vue&type=template&id=40143dec&"
import script from "./formgroupphone.vue?vue&type=script&lang=js&"
export * from "./formgroupphone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports